import {ChangeDetectorRef, Component, TemplateRef, ViewChild} from '@angular/core';
import {EnvironmentService} from './environment.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Title} from '@angular/platform-browser';
import {ConnectionService} from 'ng-connection-service';
import {ActivatedRoute, Router} from '@angular/router';
import {ZoomServiceService} from './shared/service/zoom-service.service';
import {AuthService} from './shared/service/auth.service';
import {SessionConstants} from './shared/data/sessionConstants';
import {urls} from './shared/utils/urls';
import {environment} from '../environments/environment';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {filter, take} from 'rxjs/operators';
import {SseClient} from 'ngx-sse-client';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent{
    title = 'RistaINc';
    public allow: boolean;
    public zoomAllow: boolean = true;
    isInternet = false;
    public href: any;
    favIcon: HTMLLinkElement = document.querySelector('#appIcon');
    public browserCurrentVersion = environment.version;
    public modalRef: NgbModalRef;
    @ViewChild('updateVersionNumber') updateVersionNumber: TemplateRef<any>;
    subs: Subscription[] = [];
    public popUpAlreadyOpened = false;
    public newVersionNumber = '';

    constructor(public envService: EnvironmentService, private deviceService: DeviceDetectorService, private titleService: Title,
                private connectionService: ConnectionService, public zoomService: ZoomServiceService, public cdr: ChangeDetectorRef,
                public router: Router, public auth: AuthService, public route: ActivatedRoute, public modalService: NgbModal,
                private sseClient: SseClient) {
        const url = window.location.href;
        console.log(url, 'url')
        if (url.toString().indexOf('xtracurriculum') > -1) {
            this.favIcon.href = 'assets/xtraCurriculum.ico';
            this.titleService.setTitle('XtraCurriculum');
        } else if (url.toString().indexOf('safeteen') > -1) {
            this.favIcon.href = 'assets/safeteen.png';
            this.titleService.setTitle('Safeteens - by the Teens for the Teens');
        } else if (url.toString().indexOf('elevenace') > -1) {
            this.favIcon.href = 'assets/elevenAce.ico';
            this.titleService.setTitle('ElevenAce');
        } else if (url.toString().indexOf('uniqprep') > -1) {
            this.favIcon.href = 'assets/uniqprep.png';
            this.titleService.setTitle('Uniq Prep');
        } else if (url.toString().indexOf('edveda') > -1) {
            this.favIcon.href = 'assets/edquill.ico';
            this.titleService.setTitle('EdVeda');
        } else if (url.toString().indexOf('localhost') > -1 || url.toString().indexOf('uthkal') > -1 || url.toString().indexOf('edquill') > -1) {
            this.favIcon.href = 'assets/edquill.ico';
            this.titleService.setTitle('EdQuill');
        }
        this.connectionService.monitor().subscribe(isConnected => {
            /// isconected false means no internet ...true means internet connected
            this.isInternet = isConnected.hasNetworkConnection;
            console.log(this.isInternet, 'isinrer');
        });
        this.envService.envRecieved.subscribe((res) => {
            this.allow = res;
            console.log(this.allow, 'alloe');
        });
        this.zoomService.cast.subscribe(data => {
            if (data == true) {
                console.log(data, 'data');
                // this.zoomAllow = false;
                window.location.reload();
                this.cdr.detectChanges();
                // setTimeout( ()=>{
                //     console.log('innn app comonent');
                //     this.zoomAllow = true;
                //     this.cdr.detectChanges();
                // },2000);
            }
        });
        const checkForForgotPassword = url.toString().indexOf('forgotPassword') > -1;
        const checkForSetPassword = url.toString().indexOf('setPassword') > -1;
        const checkEnrollClassCode = url.toString().indexOf('enrollclasscode') > -1;
        const checkStudentRegister = url.toString().indexOf('studentRegister') > -1;
        const viewPDF = url.toString().indexOf('viewAnswerKeyPdf') > -1;
        const preview = url.toString().indexOf('contentFolder/preview') > -1;
        const googleSignIn = url.toString().indexOf('googleSignIn') > -1;
        const googleStudentRegister = url.toString().indexOf('googleStudentRegister') > -1;
        const tutorConnect = url.toString().indexOf('tutorconnect') > -1;
        const checkForIPADApp = url.toString().indexOf('student-annotation') > -1 || url.toString().indexOf('source-link') > -1 ||
                url.toString().indexOf('student-scratch') > -1 || url.toString().indexOf('graphing') > -1 || url.toString().indexOf('ipad-question-view') > -1;
        if (!checkForForgotPassword && !checkEnrollClassCode && !checkStudentRegister && !viewPDF && !preview &&
            !googleSignIn && !googleStudentRegister && !tutorConnect && !checkForSetPassword) {
            console.log(url.split('#'), 'url_Splitted');
            const splitUrl = url.split('#');
            console.log(splitUrl, 'splitUrl');
            console.log(splitUrl.length == 1 || splitUrl.length == 2 && (['', '/'].indexOf(splitUrl[1]) > -1), 'load_condition')
            if (this.auth.loggedIn()) {
                if (splitUrl.length == 1 || splitUrl.length == 2 && (['', '/'].indexOf(splitUrl[1]) > -1)) {
                    if (['1', '2', '4'].indexOf(this.auth.getRoleId()) > -1) {
                        this.router.navigate(['/class/list-class']);
                    } else if (this.auth.getRoleId() == '3') {
                        this.router.navigate(['/repository/content-home']);
                    } else if (this.auth.getRoleId() == '5') {
                        this.router.navigate(['/student/dashboard']);
                    } else if (this.auth.getRoleId() == '6') {
                        this.router.navigate(['/dashboard/default']);
                    } else if (this.auth.getRoleId() == '7') {
                        this.router.navigate(['/student-content/list-content/old']);
                    }
                } else {
                    console.log(splitUrl[1], 'splitUrl');
                    this.router.navigate([splitUrl[1]]);
                }
            } else if (this.deviceService.getDeviceInfo().os !== 'iOS' &&
                (this.deviceService.getDeviceInfo().os !== 'Mac' || !this.deviceService.isTablet())) {
                    if (!checkForIPADApp) {
                        this.router.navigate(['/auth/login']);
                    }
            } else {
                if (!checkForIPADApp) {
                    this.router.navigate(['/auth/login']);
                }
            }
        }
        this.envService.envRecieved.pipe(
            filter((received) => received === true),
            take(1)
        ).subscribe(() => this.checkVersionNumber());
    }

    checkVersionNumber() {
        const url = window.location.href;
        const urlTypeMap = [
            { match: 'uniqprep.edquill.com', type: '25' },
            { match: 'dev.edquill.com', type: '4' },
            { match: 'test.edquill.com', type: '4' },
            // { match: 'localhost:8211', type: '4' },
            { match: 'localhost:8211', type: '25' },
            { match: 'edquill.com', type: '8' },
        ];
        const payload = {
            type: urlTypeMap.find(x => url.includes(x.match))?.type ?? '',
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        };
        this.subs.push(this.sseClient.stream(urls.getVersion, {keepAlive: true, reconnectionDelay: 300000, responseType: 'event'},
                {body: payload}, 'POST').subscribe((event) => {
                if (event.type.trim() == 'version') {
                    const versionNumberData = JSON.parse((event as MessageEvent).data);
                    if (versionNumberData.IsSuccess) {
                        if (this.browserCurrentVersion != versionNumberData.ResponseObject.version && !this.popUpAlreadyOpened) {
                            this.popUpAlreadyOpened = true;
                            this.newVersionNumber = versionNumberData.ResponseObject.version;
                            if (this.modalRef) {
                                this.modalRef.dismiss();
                            }
                            this.modalRef = this.modalService.open(this.updateVersionNumber, {backdropClass: 'static'});
                            this.modalRef.closed.subscribe( value => window.location.reload());
                        }
                    }
                }
            })
        );
    }

}
